<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to"/>
      <masked-input
        :name="validationLabel || label"
        :key="save_to"
        :required="required"
        :id="save_to"
        type="text"
        :guide="false"
        v-model="val"
        :mask="mask"
        :placeholder="placeholder"
        @blur.native="onBlur()"
        @change.native="onChange()"
        v-validate="rules"
      />
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(label)">{{ errors.first(label) }}</span>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';

export default {
  name: 'SSNFR',
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    placeholder: String,
    required: Boolean,
    unique: Boolean,
    validationLabel: String,
    _id : String,
    testmode: {
      type: Object,
    }
  },
  computed: {
    rules() {
      let unique = false;
      if(this.unique && !(this.testmode && this.testmode.active && this.testmode.disableunique)) {
        unique = [this.save_to, this.operationId]
      }
      return {
        required: this.required,
        securitesocialefr: true,
        unique
      }
    }
  },
  methods: {
    mask: function (rawValue) {
      return [/[1-2]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
    }
  }
};
</script>
